import React, { useContext } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useParams } from "react-router-dom";
import "./App.css";

import {
  UserProvider,
  UserContext,
} from "./components/0. Header/UserContext";
import Layout from "./Layout"; //Header

//Pages
import HomePage from "./pages/0. HomePage/HomePage";
import FeedPage from "./pages/0. HomePage/FeedPage";
import NotFoundPage from "./pages/0. HomePage/NotFoundPage";
import RecopiladorPage from "./pages/0. HomePage/RecopiladorPage";
import RecopiladorPracticaTsPage from "./pages/0. HomePage/RecopiladorPracticaTsPage";
import MobileHomePrototypePage from "./pages/0. HomePage/MobileHomePrototypePage";
import ManualPage from "./pages/0. HomePage/ManualPage";

import MaestrasPage from "./pages/1. Gestión de Comunidades/MaestrasPage";
import PersonasPage from "./pages/1. Gestión de Comunidades/PersonasPage";
import CursosPage from "./pages/1. Gestión de Comunidades/CursosPage";
import ActividadesPage from "./pages/1. Gestión de Comunidades/ActividadesPage";
import IniciativasPage from "./pages/1. Gestión de Comunidades/IniciativasPage";
import ProgramasPage from "./pages/1. Gestión de Comunidades/ProgramasPage";
import IniciativaFormPage from "./pages/1. Gestión de Comunidades/IniciativaFormPage";
import ComentariosPage from "./pages/1. Gestión de Comunidades/ComentariosPage";
import CumpleañosPage from "./pages/1. Gestión de Comunidades/CumpleañosPage";
import WhatsappPage from "./pages/1. Gestión de Comunidades/WhatsappPage";
import OrganizacionesPage from "./pages/1. Gestión de Comunidades/OrganizacionesPage";
import NovedadesPage from "./pages/1. Gestión de Comunidades/NovedadesPage";

import PostulantesPage from "./pages/2. Módulo de Selección/PostulantesPage";
import ProcesosPage from "./pages/2. Módulo de Selección/ProcesosPage";
import ProcesosEsperaPage from "./pages/2. Módulo de Selección/EsperaPage";
import ProcesoMaestrasPage from "./pages/2. Módulo de Selección/ProcesoMaestrasPage";
import ResumenPage from "./pages/2. Módulo de Selección/ResumenPage";

const AppLayout = ({
  children,
  blockedRoles = [],
  redirectTo = null,
}) => {
  const { roles, isLoading } = useContext(UserContext);

  const hasBlockedRole = roles.some((role) => blockedRoles.includes(role));

  if (isLoading) {
    return <Layout />;
  }

  if (hasBlockedRole && redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <Layout>
      {hasBlockedRole ? null : children}
    </Layout>
  );
};

const BLOCK_RECOPILADOR = {
  blockedRoles: ["Recopilador/a"],
  redirectTo: "/recopilador",
};

const LegacyPersonaRedirect = ({ target }) => {
  const { id } = useParams();
  return <Navigate to={id ? `${target}/${id}` : target} replace />;
};

const App = () => {
  return (
    <UserProvider>
      <Router>
        <Routes>
          {/* Intranet Home */}
          <Route
            path="/"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <HomePage />
              </AppLayout>
            }
          />
          <Route
            path="recopilador"
            element={
              <AppLayout>
                <RecopiladorPage />
              </AppLayout>
            }
          />
          <Route
            path="recopilador/practica-ts"
            element={
              <AppLayout>
                <RecopiladorPracticaTsPage />
              </AppLayout>
            }
          />
          <Route
            path="feed"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <FeedPage />
              </AppLayout>
            }
          />
          <Route
            path="manual"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ManualPage />
              </AppLayout>
            }
          />
          {/* ---------------------------------------------------------------------------------------------- */}
          {/* Gestión de Comunidades */}
          {/* Personas */}
          <Route
            path="personas/:id?"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <PersonasPage tipos={["interesada"]} titulo="Interesadas" subtitulo="Registro de personas que han pasado por RedMaestra." basePath="/personas" />
              </AppLayout>
            }
          />
          <Route
            path="comunidad/:id?"
            element={<LegacyPersonaRedirect target="/maestras" />}
          />
          <Route
            path="maestras/:id?"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <PersonasPage tipos={["maestra"]} titulo="Maestras" subtitulo="Registro de Maestras vinculadas a RedMaestra." basePath="/maestras" />
              </AppLayout>
            }
          />
          <Route
            path="participantes/:id?"
            element={<LegacyPersonaRedirect target="/personas" />}
          />
          <Route
            path="interesadas/:id?"
            element={<LegacyPersonaRedirect target="/personas" />}
          />
          {/* Maestras */}
          <Route
            path="todas"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="todas/:rut"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="maestras_externas"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="maestras_externas/:rut"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="alumna"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="alumna/:rut"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="especial"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route
            path="especial/:rut"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <MaestrasPage />
              </AppLayout>
            }
          />
          <Route path="api/perfiles/anadir_maestras/" />
          <Route path="api/perfiles/editar_maestras/:rut/" />
          {/* Cursos */}
          <Route
            path="cursos"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <CursosPage />
              </AppLayout>
            }
          />
          <Route
            path="cursos/:id"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <CursosPage />
              </AppLayout>
            }
          />
          <Route path="api/perfiles/anadir_cursos/" />
          <Route path="api/perfiles/editar_cursos/:id/" />
          {/* Actividades */}
          <Route
            path="actividades"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ActividadesPage />
              </AppLayout>
            }
          />
          <Route
            path="actividades/:id"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ActividadesPage />
              </AppLayout>
            }
          />
          <Route path="api/perfiles/anadir_actividades/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/perfiles/editar_actividades/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/perfiles/actividad_anadir_maestra/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/perfiles/actividad_anadir_maestra/aviso/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Iniciativas (parallel unified module) */}
          <Route
            path="programas"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ProgramasPage />
              </AppLayout>
            }
          />
          <Route
            path="programas/:id"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ProgramasPage />
              </AppLayout>
            }
          />
          <Route
            path="iniciativas"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <IniciativasPage />
              </AppLayout>
            }
          />
          <Route
            path="iniciativas/nueva"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <IniciativaFormPage />
              </AppLayout>
            }
          />
          <Route
            path="iniciativas/:id/editar"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <IniciativaFormPage />
              </AppLayout>
            }
          />
          <Route
            path="iniciativas/:id"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <IniciativasPage />
              </AppLayout>
            }
          />
          <Route
            path="proyectos"
            element={<Navigate to="/iniciativas" replace />}
          />
          <Route
            path="proyectos/:id"
            element={<LegacyPersonaRedirect target="/iniciativas" />}
          />
          {/* Comentarios */}
          <Route
            path="comentarios"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ComentariosPage />
              </AppLayout>
            }
          />
          {/* Solicitudes */}
          <Route
            path="solicitudes"
            element={<Navigate to="/personas" replace />}
          />
          <Route path="api/formularios/ver_maestra/:rut/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Cumpleaños */}
          <Route
            path="cumpleaños"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <CumpleañosPage />
              </AppLayout>
            }
          />
          {/* ---------------------------------------------------------------------------------------------- */}
          {/* Módulo de Selección */}
          {/* Postulaciones */}
          <Route path="api/seleccion/agregar_postulante_proceso/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Entrevista */}
          <Route
            path="postulantes"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <PostulantesPage />
              </AppLayout>
            }
          />
          <Route path="api/seleccion/editar_postulante_entrevista/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Psicoanalisis */}
          <Route
            path="procesos"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ProcesosPage />
              </AppLayout>
            }
          />
          <Route
            path="espera"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ProcesosEsperaPage />
              </AppLayout>
            }
          />
          <Route
            path="proceso_maestras"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ProcesoMaestrasPage />
              </AppLayout>
            }
          />
          <Route path="api/seleccion/editar_postulante_psicoanalisis/:id/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* Historial */}
          <Route
            path="resumen"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <ResumenPage />
              </AppLayout>
            }
          />
          {/* ---------------------------------------------------------------------------------------------- */}
          {/* Otros */}
          {/* Whatsapp */}
          <Route
            path="whatsapp"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <WhatsappPage />
              </AppLayout>
            }
          />
          <Route
            path="organizaciones/:id?"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <OrganizacionesPage />
              </AppLayout>
            }
          />
          <Route
            path="novedades/:tipo?/:id?"
            element={
              <AppLayout {...BLOCK_RECOPILADOR}>
                <NovedadesPage />
              </AppLayout>
            }
          />
          <Route
            path="prototipo-home-mobile"
            element={<MobileHomePrototypePage />}
          />
          {/* Admin */}
          <Route path="admin/" />
          <Route path="api/perfiles/maestras/?excel=true" />
          <Route path="api/generar_qr/" />
          {/* Public */}
          <Route path="api/formularios/agregar_comunidades/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/formularios/agregar_comunidades/aviso/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/formularios/agregar_empresas/" />{" "}
          {/* TEMPLATE DJANGO */}
          <Route path="api/formularios/agregar_empresas/aviso/" />{" "}
          {/* TEMPLATE DJANGO */}
          {/* ---------------------------------------------------------------------------------------------- */}
          {/* Catch-all route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </UserProvider>
  );
};

export default App;
